var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlsStorageGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#99a3b3",
    rx: 2,
    transform: "matrix(-1 0 0 1 22 2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#99a3b3",
    rx: 2,
    transform: "matrix(-1 0 0 1 11 2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#99a3b3",
    rx: 2,
    transform: "matrix(-1 0 0 1 22 13)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#99a3b3",
    rx: 2,
    transform: "matrix(-1 0 0 1 11 13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsStorageGrid);
export default __webpack_public_path__ + "static/media/controls-storage-grid.4d4bf5988759c192178836fa8281b3f7.svg";
export { ForwardRef as ReactComponent };